import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingBubbleOrganisms from '../components/organisms/LoadingBubbleOrganisms';
import MenuBarsTemplate from '../components/templates/MenuBarsTemplate';
import { useAuth } from '../controllers/services/useAuth';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute = ({ children }: PublicRouteProps) => {
  const { useGetAuth } = useAuth();
  const { isLoading, data } = useGetAuth();

  if (isLoading) {
    return (
      <MenuBarsTemplate title="">
        <LoadingBubbleOrganisms />
      </MenuBarsTemplate>
    );
  }

  if (data !== undefined && Object.keys(data).length) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default PublicRoute;